// extracted by mini-css-extract-plugin
module.exports = {"container":"e_oy","up":"e_py","down":"e_qy","percent":"e_ry","percentVal":"e_sy","title":"e_ty","tags":"e_uy","textBadge":"e_vy"};